// Contentful
import React from 'react';
import safeJsonStringify from 'safe-json-stringify';
import contentfulClient from '../client/contentful';

// Components
import CallToAction from '../components/CallToAction/CallToAction';
import CategoryHeader from '../components/CategoryHeader/CategoryHeader';
import CategoryLayout from '../components/CategoryLayout/CategoryLayout';
import ExplainerBlock from '../components/ExplainerBlock/ExplainerBlock';
import Footer from '../components/Footer/Footer';
import Navigation from '../components/Navigation/Navigation';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import PlaybooksHighlight from '../components/PlaybooksHighlight/PlaybooksHighlight';
import StoriesBlock from '../components/StoriesBlock/StoriesBlock';
import SeoMeta from '../components/SeoMeta/SeoMeta';
import TestimonialsBlock from '../components/TestimonialsBlock/TestimonialsBlock';

// Data Utils
import getExplainerBlockData from '../utils/data/getExplainerBlockData';
import getPlaybooksHighlightData from '../utils/data/getPlaybooksHighlightData';
import getStoriesBlockData from '../utils/data/getStoriesBlockData';
import getTestimonialsBlockData from '../utils/data/getTestimonialsBlockData';
import getCategoryHeaderData from '../utils/data/getCategoryHeaderData';
import getCallToActionData from '../utils/data/getCallToActionData';
import getSeoData from '../utils/data/getSeoData';
import useOpenGraphImage from '../utils/useOpenGraphImage';

const ConversionCommunity = (props) => {
  const data = props.data.fields;
  const categoryHeaderData = getCategoryHeaderData(data);
  const explainerBlockData = getExplainerBlockData(data);
  const testimonalsBlockData = getTestimonialsBlockData(data);
  const playbooksHighlightData = getPlaybooksHighlightData(data);
  const callToActionMidData = getCallToActionData(data.cta);
  const storiesBlockData = getStoriesBlockData(data);
  const callToActionBottomData = getCallToActionData(data.footerCta);

  const { seoImageURL } = useOpenGraphImage('/community');
  const seoData = getSeoData(data, seoImageURL);

  return (
    <>
      <SeoMeta {...seoData} />
      <PageWrapper>
        <Navigation modifier="Navigation--tolopeaPurple" />
        <CategoryLayout
          headerContent={
            <>
              {categoryHeaderData && <CategoryHeader {...categoryHeaderData} />}
              {testimonalsBlockData && <TestimonialsBlock {...testimonalsBlockData} />}
            </>
          }
          mainContent={
            <>
              {playbooksHighlightData && <PlaybooksHighlight {...playbooksHighlightData} />}
              {callToActionMidData && <CallToAction {...callToActionMidData} source="community" />}
              {explainerBlockData && <ExplainerBlock {...explainerBlockData} />}
              {storiesBlockData && <StoriesBlock {...storiesBlockData} />}
            </>
          }
        />
        {callToActionBottomData && <CallToAction {...callToActionBottomData} source="community" />}
        <Footer />
      </PageWrapper>
    </>
  );
};

export async function getStaticProps() {
  let data = {};

  const client = contentfulClient;

  await client.getEntry('1h9gF7G2b1tLMGpC8rIUmd', { include: 10 }).then((entry) => {
    data = JSON.parse(safeJsonStringify(entry));
  });
  return {
    props: { data }, // will be passed to the page component as props
  };
}

export default ConversionCommunity;
